import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as ClientActions from '../actions/ClientActions';
import ClientSidePane from '../components/ClientSidePane';
import ClientTimeline from '../components/client-timeline/ClientTimeline';
import { openModal } from '../actions/ModalActions';
import NoteModal from '../components/NoteModal';
import ScheduleModal from '../components/ScheduleModal';
import LoadingIndicator from '../components/LoadingIndicator';
import APIErrorAlert from '../components/APIErrorAlert';
import ClientDynamicNotes from '../components/clients/ClientDynamicNotes';
import ClientDiscountsPanel from '../components/discounts/ClientDiscountsPanel';
import ClientStatus from '../components/clients/ClientStatus';
import Dock from '../components/dock/Dock';
import ScheduleWizardDock from '../components/schedule-wizard/LogCallDockForm';
import { openWizardForUnscheduledCall, closeWizard, changeWidth, changePosition } from '../components/schedule-wizard/logActivityReducer';

var unMountClientPage = () => ({type: 'UNMOUNT_CLIENT_PAGE'});

@connect(
    state => ({
        isLoaded: state.activeClient.loaded,
        client: state.activeClient.client,
        staff: state.users.users,
        contacts: state.activeClient.contacts,
        errorLoadingClient: state.activeClient.errorLoadingClient,
        duplicates : state.activeClient.duplicates,
        query: state.routing.query,
        routing: state.routing,
        isWizardOpen: state.logActivityWizard.isOpen,
        wizardPosition: state.logActivityWizard.wizardPosition,
        wizardWidth: state.logActivityWizard.wizardWidth,
        fetchOnMount: state.activeClient.fetchOnMount,
    }),
    { openModal, ...ClientActions, openWizardForUnscheduledCall, closeWizard, changeWidth, changePosition, unMountClientPage }
)
export default class Client extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noteValue : '',
        }
    }
    componentDidMount() {
        if(this.props.fetchOnMount) {
            var clientId = this.props.routeParams.id;
            this.props.fetchClient(clientId);   
        }
    }
    componentWillUnmount() {
        this.props.unMountClientPage();
    }
    newNote(){
        this.props.openModal(NoteModal, {clientId: this.props.client.id});
    }
    newSchedule(){
        this.props.openModal(ScheduleModal, {
            clientId: this.props.client.id
        });
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.client && nextProps.client.publicId){
            document.title = "#" + nextProps.client.publicId + " " + nextProps.client.name + " | Fergus CRM";
        }

        if(this.props.routeParams.id != nextProps.routeParams.id) {
            this.props.fetchClient(nextProps.routeParams.id);
        }
    }
    componentWillUnmount(){
        document.title = "Fergus CRM";
    }

    render() {
        var { isWizardOpen, isLoaded, closeWizard, wizardWidth, wizardPosition, changeWidth, changePosition } = this.props;
        
        if(this.props.errorLoadingClient) {
            return (<APIErrorAlert error={this.props.errorLoadingClient} />);
        }
        if(! isLoaded) {
            var loadingContainerStyle = {
                height: '500px',
                justifyContent: 'center',
                alignItems: 'center'
            };
            
            return (
                <div className="flex-container" style={loadingContainerStyle}>
                    <LoadingIndicator />
                </div>
            );
        }

        return (
            <div className="row">
                <ol className="breadcrumb page-breadcrumb">
                    <li><Link to="/clients">Clients</Link></li>
                    <li className="active">{this.props.client.name} </li>
                </ol>
            
                { this.props.client.apiError &&                    
                    <div className="alert alert-danger">
                        <h2><i className="fa fa-warning"></i>  &nbsp;{this.props.client.apiError}
                        </h2>                        
                    </div>                        
                }
                <div className="col-md-4 client-left-hand-side">
                    <ClientSidePane staff={this.props.staff} client={this.props.client} contacts={this.props.contacts} duplicates={this.props.duplicates} />
                </div>
                <div className="col-md-8 page-todo client-right-hand-side">
                    <div style={{marginBottom: "25px", display: "flex"}}>
                        <ClientStatus openModal={this.props.openModal} client={this.props.client} />
                        
                        <div style={{flex: 1, marginLeft: 15, minWidth: "1px"}}>
                            <ClientDynamicNotes client={this.props.client} />
                        </div>
                    </div>
                    <ClientDiscountsPanel client={this.props.client} />
                    <ClientTimeline />
                </div>
                <div className="col-md-1"></div>

                {isWizardOpen &&
                    <Dock position={wizardPosition} changeWidth={changeWidth} changePosition={changePosition} width={wizardWidth} onClose={closeWizard}>
                        <ScheduleWizardDock />
                    </Dock>
                }
                
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/Client.js